import React, { useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";

const StyledInput = styled.input.attrs({ readOnly: true })`
  height: 50px;
  border-radius: 11px;
  border: 1px solid #c4c9ce;
  background: #fff !important;
  cursor: pointer;
  width: 100%;
  padding: 0 15px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

const CustomHeader = ({
    date,
    changeMonth,
    changeYear,
    decrementMonth,
    incrementMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
}) => {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const years = Array.from({ length: 20 }, (_, i) => date.getFullYear() - 10 + i);

    return (
        <div className="custom-header">
            <select
                value={date.getMonth()}
                onChange={e => changeMonth(e.target.value)}
            >
                {months.map((month, i) => (
                    <option key={month} value={i}>
                        {month}
                    </option>
                ))}
            </select>
            <select value={date.getFullYear()} onChange={e => changeYear(e.target.value)}>
                {years.map(year => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </div>
    );
};

const LeaveDatePick = (props) => {
    return (
        <div>
            <DatePicker
                customInput={<StyledInput />}
                selected={props.value ? (moment.isMoment(props.value) ? props.value.toDate() : new Date(props.value)) : null}
                minDate={props.minDate}
                dateFormat="dd/MM/yyyy"
                className="form-control"
                placeholderText="Select Date"
                portalId="root"
                // maxDate={new Date()}
                onChange={date => {
                    props.handleDateChange(date)
                }}
                renderCustomHeader={({
                    date,
                    changeMonth,
                    changeYear,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled
                }) => (
                    <CustomHeader
                        date={date}
                        changeMonth={changeMonth}
                        changeYear={changeYear}
                        decrementMonth={decreaseMonth}
                        incrementMonth={increaseMonth}
                        prevMonthButtonDisabled={prevMonthButtonDisabled}
                        nextMonthButtonDisabled={nextMonthButtonDisabled}
                    />
                )}
            />
        </div>
    );
};

export default LeaveDatePick;
